import { TaskStatusEnum } from "enums/TaskStatusEnum";
import { NumberChoiceModel } from "models/ChoiceModel";
import { TranslationsContextProps } from "providers";

export function getTaskStatuses(i18n: TranslationsContextProps): NumberChoiceModel[] {
  return [
    {
      value: TaskStatusEnum.Unknown,
      name: TaskStatusEnum[TaskStatusEnum.Unknown],
      text: i18n.TaskStatus_Default,
      tooltip: "",
      disabled: false,
      isDefault: false,
    },
    {
      value: TaskStatusEnum.NotStarted,
      name: TaskStatusEnum[TaskStatusEnum.NotStarted],
      text: i18n.TaskStatus_NotStarted,
      tooltip: "",
      disabled: false,
      isDefault: true,
    },
    {
      value: TaskStatusEnum.InProgress,
      name: TaskStatusEnum[TaskStatusEnum.InProgress],
      text: i18n.TaskStatus_InProgress,
      tooltip: "",
      disabled: false,
      isDefault: false,
    },
    {
      value: TaskStatusEnum.Deferred,
      name: TaskStatusEnum[TaskStatusEnum.Deferred],
      text: i18n.TaskStatus_Deferred,
      tooltip: "",
      disabled: false,
      isDefault: false,
    },
    {
      value: TaskStatusEnum.WaitingOnSomeoneElse,
      name: TaskStatusEnum[TaskStatusEnum.WaitingOnSomeoneElse],
      text: i18n.TaskStatus_WaitingOnSomeoneElse,
      tooltip: "",
      disabled: false,
      isDefault: false,
    },
    {
      value: TaskStatusEnum.Complete,
      name: TaskStatusEnum[TaskStatusEnum.Complete],
      text: i18n.TaskStatus_Complete,
      tooltip: "",
      disabled: false,
      isDefault: false,
    },
    {
      value: TaskStatusEnum.Archived,
      name: TaskStatusEnum[TaskStatusEnum.Archived],
      text: i18n.TaskStatus_Archived,
      tooltip: "",
      disabled: false,
      isDefault: false,
    },
    {
      value: TaskStatusEnum.Deleted,
      name: TaskStatusEnum[TaskStatusEnum.Deleted],
      text: i18n.TaskStatus_Default,
      tooltip: "",
      disabled: false,
      isDefault: false,
    },
  ];
}
